<template>
  <PosMobile
    v-if="this.device.isMobile"
  />
  <PosDesktop
    v-else
  />
</template>

<script>
import PosDesktop from '@/components/apps/pos/sale/main/Main'
import PosMobile from '@/components/apps/pos/sale/mobile/Main'

export default {
  components: {
    PosDesktop,
    PosMobile,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/Session.vue